import styled from 'styled-components'
import { desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    position: relative;
    overflow: hidden;
    width: inherit;
    padding: 2rem 1rem 1rem;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1.5rem;
    }
`

export const Title = styled.h2`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: ${props => props.theme.typography.font.lato.weight.bold};
    font-size: 1.25rem;
    line-height: 1.625rem;
    letter-spacing: -0.6px;
    margin-bottom: 0.5rem;
    color: ${props => props.theme.colors.tfwBlack87};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 2rem;
        line-height: 2.5rem;
    }
`

export const CardsContainer = styled.div`
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    padding: 0.5rem 1rem;

    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        gap: 1.5rem;
        padding: 0.5rem 0.25rem;
    }
`

export const Card = styled.div`
    position: relative;
    flex-shrink: 0;
    min-width: 200px;
    width: 200px;
    height: 150px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition:
        transform 0.3s ease,
        box-shadow 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    contain: layout;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: 220px;
        border-radius: 12px;
        height: 165px;
    }
`

export const ImageWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;

    img {
        object-fit: cover;
    }
`

export const CardContent = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
`

export const BlurBackdrop = styled.div`
    position: absolute;
    width: 126px;
    height: 150px;
    border-radius: 8px 0 100px 8px;
    backdrop-filter: blur(7px);
    background: rgba(255, 255, 255, 0.6);
    z-index: 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: 139px;
        height: 165px;
        border-radius: 8px 0 110px 8px;
        backdrop-filter: blur(8px);
    }
`

export const ContentWrapper = styled.div`
    position: relative;
    z-index: 1;
    min-width: 99px;
    height: 150px;
    padding: 11px 0 0 11px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: 126px;
        height: 165px;
        padding: 13px 0 7px 13px;
    }
`

export const CardTop = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    max-width: 100%;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        gap: 3px;
    }
`

export const CardTitle = styled.h3`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.875rem;
    line-height: 1.375rem;
    font-weight: ${props => props.theme.typography.font.lato.weight.bold};
    margin: 0;
    color: ${props => props.theme.colors.tfwBlack87};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 0.9375rem;
        line-height: 1.5rem;
    }
`

export const CardSubtitle = styled.p`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: ${props => props.theme.typography.font.weight.normal};
    font-style: normal;
    font-size: 0.75rem;
    line-height: 1rem;
    margin: 0;
    color: ${props => props.theme.colors.tfwBlack87};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: 0.8125rem;
        line-height: 1.125rem;
    }
`

export const CardBottom = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    max-width: 100%;
    padding-bottom: 11px;
`

export const CheckButton = styled.button`
    width: 80px;
    height: 24px;
    min-width: 80px;
    border-radius: 5.8px;
    background-color: ${props => props.theme.colors.tfwBlack87};
    color: ${props => props.theme.colors.white};
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: ${props => props.theme.typography.font.lato.weight.semiBold};
    font-size: 0.625rem;
    line-height: 1.0625rem;

    &:hover {
        background-color: ${props => props.theme.colors.tfwBlack87};
    }
`
